<template>
    <template-card-v2 :one-log="oneLog" :linkedtype="linkedtype" :linkedid="linkedid">
        <template #icon>
            <CompassObject object="marketing" size="small" />
        </template>
        <template #label>
            <person-list-light
                v-if="oneLog.hasOwnProperty('contacts')"
                :list="oneLog.contacts.params.list"
                placeholder-singular="Collaborateur"
                placeholder-plural="Collaborateurs"
            >
            </person-list-light>
            <person-list-light
                v-else-if="oneLog.hasOwnProperty('thirds')"
                :list="oneLog.thirds.params.list"
                placeholder-singular="Société"
                placeholder-plural="Sociétés"
            >
            </person-list-light>
        </template>

        <template #content>
            <div>
                <div
                    class="marketing-card__content-description typographies-paragraph-medium-regular"
                >
                    {{ getWording(oneLog.event, oneLog.eventDetails) }}
                </div>
            </div>
        </template>

        <!-- DROPDOWN -->
        <template v-if="canSeeDropdown" #aside>
            <div>
                <el-dropdown>
                    <CompassIconButton icon="action" size="small"></CompassIconButton>
                    <template #dropdown>
                        <el-dropdown-menu>
                            <el-dropdown-item
                                v-if="canTogglePin"
                                :disabled="!!intervalCallidES"
                                @click.native="
                                    togglePin(isPinned, {
                                        userForename: userForename,
                                        userName: userName,
                                    })
                                "
                            >
                                {{ pinStatusLabel }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="oneLog.canSee"
                                @click.native="previewEvent(oneLog)"
                            >
                                {{ $l10n.__('Voir') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="oneLog.can_edit"
                                @click.native="editEvent(oneLog)"
                            >
                                {{ $l10n.__('Modifier') }}
                            </el-dropdown-item>
                            <el-dropdown-item
                                v-if="oneLog.can_edit"
                                @click.native="deleteEvent(oneLog)"
                            >
                                {{ $l10n.__('Supprimer') }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
            </div>
        </template>
    </template-card-v2>
</template>

<script>
import TemplateCardV2 from './TemplateCardV2.vue';
import TimelineCardMixin from './TimelineCardMixin.js';
import TimelineWordingMixin from './TimelineWordingMixin';
import PersonListLight from 'vcomponents/utilities/PersonListLight.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapStateUser } = createNamespacedHelpers('user');

export default {
    components: {
        TemplateCardV2,
        PersonListLight,
    },
    mixins: [TimelineCardMixin, TimelineWordingMixin],
    data() {
        return {
            lang: this.$parent.lang,
        };
    },
    computed: {
        ...mapStateUser({
            timezone: 'timezone',
            userForename: 'forename',
            userName: 'name',
        }),
    },
};
</script>

<style lang="scss" scoped>
.marketing-card {
    &__content {
        &-description {
            margin-top: var(--spacing-1);
        }
    }
}
</style>
